/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { Status } from "../../models/status";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface RoleZonesAdd$Params {
  organisation_id: string;
  role_id: string;
  zone_id: string;
}

export function roleZonesAdd(
  http: HttpClient,
  rootUrl: string,
  params: RoleZonesAdd$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Status>> {
  const rb = new RequestBuilder(rootUrl, roleZonesAdd.PATH, "post");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("role_id", params.role_id, {});
    rb.path("zone_id", params.zone_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Status>;
    }),
  );
}

roleZonesAdd.PATH = "/surfdomeinen/organisations/{organisation_id}/auth/roles/{role_id}/zones/{zone_id}";
